import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import { IDraw } from "./draw.types"

dayjs.extend(utc)

export const startDateFloor = (
  draws: Pick<IDraw, "entryDeadlineDateTime">[],
): Date | undefined => {
  if (!draws.length) return undefined
  const latest = draws.reduce(
    (max, d) =>
      d.entryDeadlineDateTime.isAfter(max) ? d.entryDeadlineDateTime : max,
    draws[0].entryDeadlineDateTime,
  )
  return latest.utc().add(1, "day").startOf("day").toDate()
}
